"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _ParagraphText = _interopRequireDefault(require("../../BasicTextElements/ParagraphText"));

var _Checklist = require("./Checklist.styles");

var _text = require("../../../../styles/2_commonComponentStyles/text");

var _iconNames = _interopRequireDefault(require("../../../../constants/iconNames"));

var _idGenerator = _interopRequireDefault(require("../../../../utils/idGenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The checklist component wraps up checklist items to show the user a set of steps, completed or otherwise.
 */
// intentionally left as a functional component
var Checklist = function Checklist(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      items = _ref.items,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["className", "dataTestId", "items", "title"]);

  return /*#__PURE__*/_react.default.createElement(_Checklist.StyledChecklist, _extends({}, props, {
    "data-test-id": dataTestId,
    className: className
  }), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
    className: "c-checklist-title",
    dataTestId: "checklist-title"
  }, /*#__PURE__*/_react.default.createElement("strong", {
    "data-test-id": "checklist-title"
  }, title)), /*#__PURE__*/_react.default.createElement("table", {
    className: "c-checklist-items-wrapper",
    "data-test-id": "checklist-items-wrapper"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "".concat(item.iconName, "-").concat((0, _idGenerator.default)()),
      "data-test-id": "checklist-item"
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "c-checklist-item-content",
      "data-test-id": "checklist-item-content"
    }, item.content), /*#__PURE__*/_react.default.createElement("td", {
      className: "c-checklist-item-icon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      colorTheme: item.colorTheme,
      dataTestId: "checklist-item-icon",
      iconName: item.iconName
    })));
  }))));
};

Checklist.propTypes = {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Items for the checklist, consisting of text, and iconName and optional colorTheme */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Single or array of html nodes */
    content: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),

    /** see `/constants/iconNames.js` for full list */
    iconName: _propTypes.default.oneOf(_iconNames.default),

    /** see `/constants/baseColorThemes.js` for full list */
    colorTheme: _propTypes.default.oneOf(_text.textThemes)
  })),

  /** Top level title for the checklist */
  title: _propTypes.default.string
};
Checklist.defaultProps = {
  items: [],
  className: '',
  title: ''
};
var _default = Checklist;
exports.default = _default;